// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fr-hide-label > .ant-form-item-row > .ant-form-item-label {\n  visibility: hidden;\n}\n.fr-field .ant-form-item-row {\n  flex-wrap: nowrap;\n}\n.fr-field .ant-form-item-control-input-content {\n  display: flex;\n}\n.fr-field-visibility {\n  width: 0;\n  height: 0;\n  visibility: hidden;\n  position: absolute;\n  opacity: 0;\n}\n.fr-form .ant-form-item-control {\n  width: 0;\n}\n.fr-form .fr-inline-field .ant-form-item-control {\n  width: auto;\n}\n", ""]);
// Exports
module.exports = exports;
